import { useEffect, type ReactNode } from "react";
import { LoggerFactory } from "@/infrastructure/services/logger/logger.factory";

interface LoggerProviderProps {
  children: ReactNode;
}

export const LoggerProvider = ({ children }: LoggerProviderProps) => {
  useEffect(() => {
    LoggerFactory.getInstance();
  }, []);

  return children;
};
